<template>
  <div>
    <app-bar></app-bar>
    <menu-master></menu-master>
    <v-main>
      <v-row :style="withS">
        <v-col>
          <router-view />
        </v-col>
      </v-row>
    </v-main>
    <v-overlay :value="overlay" opacity="0.7"> </v-overlay>
  </div>
</template>

<script>
import AppBar from "../components/General/AppBar";
import MenuMaster from "../components/General/Menu";
//import bus from "../events/bus";

export default {
  components: {
    AppBar,
    MenuMaster,
  },

  data() {
    return {
      overlay: false,
    };
  },

  mounted() {
    // this.overlay = true;
    // bus.$emit("loadSettings", true);
    // setTimeout(() => {
    //   this.$store
    //     .dispatch("businessSelectAction") //cargo las empresas del usuario
    //     .then(() => {
    //       let businessDefault = this.$store.getters.getBusinessSelected;
    //       let countryId = businessDefault.country_id;
    //       this.$store
    //         .dispatch("settingsAction", countryId) //cargo la configuracion de la empresa default
    //         .then(() => {
    //           bus.$emit("loadSettings", false);
    //           this.overlay = false;
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //         });
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // }, 1000);
  },

  computed: {
    withS() {
      let w = window.screen.width;
      if (w < 950) {
        return "max-width: 100%; margin: 0 auto";
      }
      return "max-width: 75%; margin: 0 auto";
    },
  },
};
</script>

<style></style>
